import React, { useState } from "react";
import AdminNavigation from "../AdminNavigation";
import { API_BASE_URL } from "../../..";
const PreviewImage = () => {
  const [inputId, setInputId] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [error, setError] = useState("");

  // const fetchImage = () => {
  //   fetch(`${API_BASE_URL}api/images/${id}`, { credentials: "include" })
  //     .then((res) => res.json())
  //     .then((data) => {
  //       if (data.url) {
  //         setImgSrc(data.url);
  //       } else {
  //         alert("Image not found!");
  //         setImgSrc("");
  //       }
  //     });
  // };
  const handleFetch = () => {
    if (!inputId.trim()) {
      setError("Please enter an image ID");
      return;
    }
    fetchAndSetImage(inputId.trim());
  };
  const fetchAndSetImage = (id) => {
    fetch(`${API_BASE_URL}rest/admin/images/${id}`, { credentials: "include" })
      .then((response) => {
        if (!response.ok) throw new Error("Image not found");
        return response.blob();
      })
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        setImageUrl(url);
        setError("");
      })
      .catch((e) => {
        setImageUrl("");
        setError(e.message);
      });
  };

  return (
    <div className="v2_container">
      <div className="row">
        <AdminNavigation className="col-xl-2 col-lg-3 col-md-4 col-6" />
        <div className="col-xl-10 col-lg-9 col-md-8 col-6 p-l-15">
          <div className="row">
            <h2>Preview Image</h2>
            <input
              type="text"
              placeholder="Enter ID"
              value={inputId}
              onChange={(e) => setInputId(e.target.value)}
            />
            <button onClick={handleFetch}>Fetch</button>
            {imageUrl && (
              <img
                src={imageUrl}
                alt="Preview"
                style={{ maxWidth: 400, maxHeight: 400 }}
                onError={() => setError("Image not found.")}
              />
            )}
            {error && <div style={{ color: "red" }}>{error}</div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewImage;



// WEBPACK FOOTER //
// ./src/mi-app/adminPanel/Content Management/PreviewImage.js